module.exports = __webpack_public_path__ + "assets/img/hj1.8be35205.png";